import axios from "axios";
import {API_URL} from "../../../utils/apiURLs";

export function getProductList(params) {
  return axios.get(`${API_URL.PRODUCT_LIST}`, {params});
}

export function getProductById(productId) {
  return axios.get(`${API_URL.PRODUCT_LIST}/${productId}`);
}
